import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { httpservice, Message } from 'src/app/commons/commons.module';
import { formatDate } from '@angular/common';
import * as saveAs from "file-saver";
import { MatDatepickerIntl } from '@angular/material/datepicker';

@Component({
  selector: 'requests-print',
  templateUrl: './requests-print.component.html'
})

export class RequestsPrintComponent implements OnInit {
  getservice: httpservice;
  oddana: Date;
  dodana: Date;

  constructor(dataservice: httpservice, @Inject(LOCALE_ID) private locale: string) {
    this.getservice = dataservice;

  }

  ngOnInit() {
    this.oddana = new Date();
    this.dodana = new Date();
  }

  Ispisi() {
    this.getservice.GetRequestFile<Blob>("Request/print?oddana=" + formatDate(this.oddana, "yyyy-MM-dd", this.locale) + "&dodana=" + formatDate(this.dodana, "yyyy-MM-dd", this.locale)).subscribe((data: Blob) => {
      var file = new Blob([data], { type: 'application/pdf' })
      var fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    }, (error) => {
      console.log('getPDF error: ', error);
    }

    );
  }
}
